import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import Form from '../elements/Form'
import TextInput from '../elements/forms/TextInput'
import IntegerInput from '../elements/forms/IntegerInput'
import StaticInput from '../elements/forms/StaticInput'
import GenericSelect from '../elements/forms/GenericSelect'
import Dismissible from '../elements/Dismissible'
import AppConstants from '../../utils/AppConstants'
import AppUtils from '../../utils/AppUtils'

const ERROR = {
  EMPTY_PRODUCT: 'Veuillez sélectionner un matériel.',
  EMPTY_NAME: 'Le nom ne peut pas être vide.',
  EMPTY_PERIODICTY: 'La récurrence ne peut pas être vide.'
}

class MaintenanceForm extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      input: this.getInitialInput(props),
      formErrors: []
    }

    // Bind events
    this.onChangeInputProduct = this.onChangeInputProduct.bind(this)
    this.onChangeInputName = this.onChangeInputName.bind(this)
    this.onChangeInputPeriodicity = this.onChangeInputPeriodicity.bind(this)
    this.onChangeInputOutside = this.onChangeInputOutside.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    // Register submit event
    if (_.isFunction(this.props.registerSubmit)) {
      this.props.registerSubmit(this.onSubmit)
    }
  }

  getInitialInput(props = this.props) {
    return {
      product: props.product || null,
      name: (props.data && props.data.name) || '',
      periodicity: (props.data && props.data.periodicity) || '',
      outside: (props.data && props.data.outside) ? 'true' : 'false'
    }
  }

  setInput(input = {}) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        input
      )
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    // When async fetch finished
    if (prevProps.isLoading && !this.props.isLoading) {
      this.setState({
        input: this.getInitialInput()
      })
    }
  }

  onChangeInputProduct(product) {
    this.setInput({ product })
  }

  onChangeInputName(name) {
    this.setInput({ name })
  }

  onChangeInputPeriodicity(periodicity) {
    this.setInput({ periodicity })
  }

  onChangeInputOutside(outside) {
    this.setInput({ outside })
  }

  onSubmit() {
    // Check that fields have been filled
    const formErrors = []
    if (!this.props.data && _.isNull(this.state.input.product)) {
      formErrors.push(ERROR.EMPTY_PRODUCT)
    }
    if (!_.isString(this.state.input.name) || this.state.input.name.length === 0) {
      formErrors.push(ERROR.EMPTY_NAME)
    }
    if (String(this.state.input.periodicity).length === 0) {
      formErrors.push(ERROR.EMPTY_PERIODICTY)
    }
    this.setState({
      formErrors
    })
    if (!_.isEmpty(formErrors)) {
      return;
    }

    // Build and submit correctly formatted input
    const input = _.extend(
      _.pick(this.state.input, 'name', 'periodicity'),
      {
        outside: this.state.input.outside === 'true'
      },
      this.props.data
        ? {}
        : {
            product: {
              id: this.state.input.product
            }
          }
    )
    this.props.onSubmit(input)
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.error
            ? <Dismissible
                header={AppUtils.errorToTitle(this.props.error)}
                content={AppUtils.errorToText(this.props.error, {
                  [AppConstants.ERROR.BAD_REQUEST.UNICITY_CONSTRAINT_VIOLATION]: 'Cette maintenance existe déjà.'
                })}
                color='red'
                onDismiss={this.props.onClearError}
              />
            : null
        }
        {
          !_.isEmpty(this.state.formErrors)
            ? <Dismissible
                content='Veuillez résoudre les problèmes ci-dessous avant de poursuivre.'
                color='orange'
              />
            : null
        }
        <Form
          onSubmit={this.onSubmit}
          loading={this.props.isLoading || this.props.isSaving}
        >
          {
            this.props.data
              ? <StaticInput
                  label='Matériel'
                  content={this.props.data.product.name}
                />
              : <GenericSelect
                  label='Matériel'
                  loading={this.props.productsIsFetching}
                  canSearch={true}
                  options={
                    _.isArray(this.props.productsList)
                      ? _.map(
                          _.flatten(
                            _.map(
                              this.props.productsList,
                              (category) => (category.products)
                            )
                          ),
                          (product) => ({
                            key: product.id,
                            value: product.name
                          })
                        )
                      : []
                  }
                  selected={this.state.input.product}
                  onChange={this.onChangeInputProduct}
                  error={
                    _.contains(this.state.formErrors, ERROR.EMPTY_PRODUCT)
                      ? ERROR.EMPTY_PRODUCT
                      : null
                  }
                />
          }
          <TextInput
            label='Nom'
            placeholder='Mise en eau'
            value={this.state.input.name}
            onChange={this.onChangeInputName}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_NAME)
                ? ERROR.EMPTY_NAME
                : null
            }
          />
          <IntegerInput
            label='Tous les (mois)'
            placeholder='12'
            value={this.state.input.periodicity}
            onChange={this.onChangeInputPeriodicity}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_PERIODICTY)
                ? ERROR.EMPTY_PERIODICTY
                : null
            }
          />
          <GenericSelect
            label='Effectuée par'
            loading={false}
            options={[
              { key: 'false', value: 'SIS' },
              { key: 'true', value: 'Externe' }
            ]}
            selected={this.state.input.outside}
            onChange={this.onChangeInputOutside}
          />
        </Form>
      </React.Fragment>
    )
  }
}

MaintenanceForm.propTypes = {
  product: PropTypes.number,
  data: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  registerSubmit: PropTypes.func,
  error: PropTypes.object,
  productsList: PropTypes.array,
  productsIsFetching: PropTypes.bool
}

export default MaintenanceForm



// WEBPACK FOOTER //
// ./src/components/forms/MaintenanceForm.js